import BaseService from '@/shared/services/base.service';

class AuthService extends BaseService {
  async authorizePatient(patientMainUnique) {
    const response = await this.repository.authorizePatient(patientMainUnique);
    if (!response || response.code !== 0 || !response.payload?.token) {
      throw new Error(response?.message || 'Authorization failed');
    }
    return this.handleResponse(response);
  }

  async getMe() {
    try {
      const response = await this.repository.getMe();
      return this.handleResponse(response);
    } catch (error) {
      console.warn('[AuthService] Failed to get user info:', error.message);
      return {};
    }
  }
}

export default new AuthService('auth');
